import React from 'react';
import { Link } from 'react-router-dom';
import { trackCtaClick } from '../lib/analytics';

export function CTA() {
  return (
    <div className="bg-blue-700">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
        <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          <span className="block">
            Ready to simplify your strata management?
          </span>
          <span className="block text-blue-200">
            Get started with StrataPro today.
          </span>
        </h2>
        <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
          <div className="inline-flex rounded-md shadow">
            <Link
              to="/get-started"
              onClick={() => trackCtaClick('Get Started', 'site_cta')}
              className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50">

              Get Started
            </Link>
          </div>
          <div className="ml-3 inline-flex rounded-md shadow">
            <Link
              to="/contact"
              onClick={() => trackCtaClick('Contact Sales', 'site_cta')}
              className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500">

              Contact Sales
            </Link>
          </div>
        </div>
      </div>
    </div>);

}